import type { PluralForms } from '@/shared/lib/plural';

/** Вид типа по-человечески. */
export function kindTitle(kind: string): string {
  switch (kind) {
    case 'single':
      return 'Одна запись';
    case 'block':
      return 'Блок для страниц';
    default:
      return 'Коллекция';
  }
}

export const RECORDS: PluralForms = ['запись', 'записи', 'записей'];
/** «стоит в 1 записи / 5 записях». */
export const RECORDS_IN: PluralForms = ['записи', 'записях', 'записях'];
